<template>
    <a-modal v-model="attachCfg.visible" :title="title" centered :maskClosable="false" :keyboard="false" @ok="handleOk" width="40%" class="diyModelCls">
        <div class="attactpanel">
            <div class="attachtitle">
                附件上传
                <div class="attachicon"><a-icon type="upload" /></div>
            </div>
            <div class="attachbtn">
                <div class="attachserch"><a-input-search v-model="searchvalue" placeholder="请输入文件名" style="width: 100%;" @search="onSearch" /></div>
                <!-- 上传文件夹按钮 -->
                <a-upload
                    action="./api/jsaec/register/saveAttach"
                    :headers="headers"
                    :data="attach"
                    :multiple="false"
                    directory
                    :file-list="fileList1"
                    :showUploadList="false"
                    :before-upload="beforeUpload"
                    @change="handleChangeOfFolder"
                    style="margin-top:1em;margin-left:auto;margin-right: 1em;"
                >
                    <a-button> <a-icon type="upload" /> 选择文件夹 </a-button>
                </a-upload>
                <!-- 上传文件按钮 -->
                <a-upload
                    action="./api/jsaec/register/saveAttach"
                    :headers="headers"
                    :data="attach"
                    :multiple="true"
                    :file-list="fileList2"
                    :showUploadList="false"
                    :before-upload="beforeUpload"
                    @change="handleChangeOfFile"
                    style="margin-top:1em;"
                >
                    <a-button> <a-icon type="upload" /> 选择文件 </a-button>
                </a-upload>
            </div>
            <a-progress v-show="isShowPerc" :percent="percent" />
            <div class="attachfilelist">
                <vxe-table
                    ref="itemTable"
                    size="mini"
                    resizable
                    keep-source
                    auto-resize
                    row-id="id"
                    align="left"
                    header-align="center"
                    highlight-hover-row
                    show-overflow="tooltip"
                    :data="fileList"
                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="filename" title="文件"></vxe-table-column>
                    <vxe-table-column title="操作" width="180" align="center">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="handlePreview(scope.row)"><a-icon type="link" />预览</span>
                            <span class="btn_edit" @click="handleDownload(scope.row)"><a-icon type="download" />下载</span>
                            <span class="btn_edit" @click="handleRemove(scope.row)"><a-icon type="delete" />删除</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "AttachModalUpload",
    props: ["attachCfg"],
    data() {
        return {
            queryParams: {},
            searchvalue: "",
            attach: {},
            headers: {}, //上传请求头部
            fileList0: [],
            fileList1: [],
            fileList2: [],
            fileList: [],
            checkedKeys: [],
            selectedKeys: [],
            expandedKeys: [],
            file: {},
            percent: 0,
            isShowPerc: false,
            timerId: null
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        title() {
            return "附件管理";
        },
        // 是否显示界面
        editVisible: {
            get() {
                return this.attachCfg.visible;
            },
            set(newVal) {
                this.attachCfg.visible = newVal;
                this.$emit("update:attachCfg.visible", newVal);
            }
        }
    },
    watch: {
        attachCfg: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal.visible) {
                    this.fileList = [];
                    if (newVal.fkvalue !== null && newVal.fkvalue !== undefined && newVal.fkvalue !== "") {
                        this.queryAttachFileList();
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        //this.headers.Authorization = `Bearer ` + this.getToken;
    },
    methods: {
        queryAttachFileList() {
            this.stopProgess();
            this.queryParams.fkvalue = this.attachCfg.fkvalue;
            this.queryParams.fktable = this.attachCfg.fktable;
            this.$FG_http
                .post(
                    "./api/jsaec/register/queryAttach",
                    {
                        queryParams: this.queryParams
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.fileList = data.data.attach;
                            this.fileList0 = this.fileList;
                            this.fileList1 = [];
                            this.fileList2 = [];
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002");
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        beforeUpload(file) {
            let isnew = this.isnew;
            if (isnew) {
                this.$message.error("请先保存单据信息!");
            }
            this.attach.data = JSON.stringify(this.attachCfg);
            if (!isnew) {
                this.showProgess(file);
            }
            return !isnew;
        },
        handleChangeOfFolder(info) {
            if (info.event !== null && info.event !== undefined && info.event.type === "progress") {
                this.percent = Math.round(info.event.percent);
            }
            if (info.file.status === "removed") {
                this.deleteAttach(info.file.uid);
            }
            let fileList = [...info.fileList];
            // fileList = fileList.slice(-1); //保留最新附件
            if (info.file.status === "done") {
                //返回response
                fileList = fileList.map((file) => {
                    if (file.response) {
                        file.uid = file.response.data.ID;
                        file.url = file.response.data.ID;
                    }
                    return file;
                });
            }
            this.fileList1 = fileList;
            this.fileList = this.fileList0.concat(this.fileList1).concat(this.fileList2);
            //附件是否都已上传成功
            let state = 1;
            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].status !== "done") {
                    state = 0;
                    break;
                }
            }
            if (this.fileList.length > 0 && state === 1) {
                this.stopProgess();
                this.queryAttachFileList();
            }
        },
        handleChangeOfFile(info) {
            if (info.event !== null && info.event !== undefined && info.event.type === "progress") {
                this.percent = Math.round(info.event.percent);
            }
            if (info.file.status === "removed") {
                this.deleteAttach(info.file.uid);
            }
            let fileList = [...info.fileList];
            // fileList = fileList.slice(-1); //保留最新附件
            if (info.file.status === "done") {
                //返回response
                fileList = fileList.map((file) => {
                    if (file.response) {
                        file.uid = file.response.data.ID;
                        file.url = file.response.data.ID;
                    }
                    return file;
                });
            }
            this.fileList2 = fileList;
            this.fileList = this.fileList0.concat(this.fileList2).concat(this.fileList1);
            //附件是否都已上传成功
            let state = 1;
            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].status !== "done") {
                    state = 0;
                    break;
                }
            }
            if (this.fileList.length > 0 && state === 1) {
                this.stopProgess();
                this.queryAttachFileList();
            }
        },
        handleRemove(row) {
            this.$FG_http
                .post("./api/jsaec/register/deleteAttach", {
                    id: row.uid
                })
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.queryAttachFileList();
                    }
                });
        },
        handlePreview(row) {
            this.file = {
                uid: row.id,
                name: row.filename
            };
            this.$FG_http
                .post(
                    "./api/jsaec/register/previewAttach",
                    {
                        id: row.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        this.file.url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(this.file.url, this.file.name);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        handleDownload(row) {
            this.$FG_http
                .post(
                    "./api/jsaec/register/downloadAttach",
                    {
                        id: row.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", row.filename); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        onSearch() {
            this.queryParams.filename = this.searchvalue;
            this.fileList = [];
            this.queryAttachFileList();
        },
        handleOk() {
            this.editVisible = false;
        },
        showProgess(file) {
            this.isShowPerc = true;
            // let me = this;
            // if (this.timerId) {
            //     clearInterval(this.timerId);
            // }
            // this.timerId = setInterval(function() {
            //     //用setInterval做动画感觉有问题
            //     me.autoAddProgess();
            // }, 100);
        },
        autoAddProgess() {
            this.percent = this.percent + 1;
            if (this.percent === 99) {
                this.percent = this.percent - 10;
            }
        },
        stopProgess() {
            // if (this.timerId) {
            //     clearInterval(this.timerId);
            //     this.timerId = null;
            // }
            this.isShowPerc = false;
            this.percent = 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.attactpanel {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;
    .attachtitle {
        color: #333;
        font-size: 24px;
        font-weight: bold;
        .attachicon {
            float: right;
            cursor: pointer;
        }
    }
    .attachserch {
        margin: 1em 0 0em 0;
    }
    .attachbtn {
        display: flex;
        text-align: right;
    }
    .attachfilelist {
        margin: 10px 0;
    }
}
</style>
